<template>
  <div class="review-stars" :class="{'review-stars--large': large}">
    <div v-for="(star, index) in starsToShow" class="review-star" :class="{'review-star--active': index < active && active > 1, 'review-star--low': index < active && active == 1}"></div>
  </div>
</template>

<script>
  export default {
    name: 'review-stars',

    props: ['stars', 'active', 'large'],

    data: function () {
      return {

      }
    },

    created: function() {

    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {

    },

    computed:{
      starsToShow: function() {
        if(this.stars) {
          return this.stars;
        }

        return 5;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_mq";

  .review-stars {
    display: inline-block;
    white-space: nowrap;

    .review-star {
      display: inline-block;
      height: 2.5rem;
      width: 2.5rem;
      background: url(/static/img/star--grey.svg);
      background-repeat: no-repeat;

      @media only screen and (max-width: 1124px) {
        height: 2rem;
        width: 2rem;
      }
    }
    .review-star + .review-star {
      margin-left: 0.6rem;
    }
    .review-star--active {
      background: url(/static/img/star--yellow.svg);
      background-repeat: no-repeat;
    }

    .review-star--low {
      background: url(/static/img/star--red.svg);
      background-repeat: no-repeat;
    }

    &.review-stars--large {
      .review-star {
        height: 5.5rem;
        width: 5.5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ReviewStars.vue?55c641c0